/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Price_MaxInputs */

const cs_filter_price_max = /** @type {(inputs: Filter_Price_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena do`)
};

const en_filter_price_max = /** @type {(inputs: Filter_Price_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price to`)
};

/**
* | output |
* | --- |
* | "Price to" |
*
* @param {Filter_Price_MaxInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_price_max = /** @type {((inputs?: Filter_Price_MaxInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Price_MaxInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_price_max(inputs)
	return cs_filter_price_max(inputs)
});